import parse from "html-react-parser";
import { MapString2Boolean } from "model/general";

export const findArrayObjectbyAttr = (
  array: any,
  attr: string,
  value: string
): any => {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return array[i];
    }
  }
  return null;
};

export const hashCode = (str: string): number => {
  return Array.from(str).reduce(
    (aggr: number, char: string) =>
      (aggr * 31 + char.charCodeAt(0)) & 0x7fffffff,
    0
  );
};

export const saveBlobToFile = (blob: Blob, filename: string) => {
  const a = document.createElement("a");
  a.href = window.URL.createObjectURL(blob);
  a.download = filename;
  a.click();
};

export const parseUrlsToHtmlLinks = (text: string, target?: string) => {
  if (!text) return "";
  const newText = text.replace(
    // eslint-disable-next-line
    /(\b(https|http):\/\/[A-Z0-9_.\-\/]*[A-Z0-9\/]+)/gim,
    '<a href="$1"' + (target ? ' target="' + target + '"' : "") + ">$1</a>"
  );
  return parse(newText);
};

export const arabicToRoman = (num: number): string => {
  const roman: any = {
    M: 1000,
    CM: 900,
    D: 500,
    CD: 400,
    C: 100,
    XC: 90,
    L: 50,
    XL: 40,
    X: 10,
    IX: 9,
    V: 5,
    IV: 4,
    I: 1,
  };
  var str = "";

  for (var i of Object.keys(roman)) {
    var q = Math.floor(num / roman[i]);
    num -= q * roman[i];
    str += i.repeat(q);
  }

  return str;
};

export const removeUnprintableChars = (text: string): string => {
  if (!text) return "";

  const newText: number[] = [];
  let strip = false;

  for (let i = 0; i < text.length; i++) {
    const charCode = text.charCodeAt(i);
    if (charCode >= 0x2000 && charCode <= 0x206f) {
      strip = true;
      continue;
    }
    newText.push(charCode);
  }

  if (!strip) return text;
  return String.fromCharCode(...newText);
};


export const _matchTag = (tag: string, tags?: string[], extra?: MapString2Boolean): boolean => {
  const reverse = tag.startsWith("!");
  if (reverse) tag = tag.substring(1);
  const match = (tags?.includes(tag) || (extra && extra[tag])) || false;
  return reverse ? !match : match;
}


export const matchTagsOr = (find: string | string[], tags?: string[], extra?: MapString2Boolean): boolean => {
  return matchTags(find, tags, extra, false);

};
export const matchTagsAnd = (find: string | string[], tags?: string[], extra?: MapString2Boolean): boolean => {
  return matchTags(find, tags, extra, true);

};

const matchTags = (
  find: string | string[],
  tags: string[] | undefined,
  extra: MapString2Boolean | undefined,
  opAnd: boolean = false // AND or OR
): boolean => {
  if (!find) return false;

  const findIsArray = Array.isArray(find);
  if (!findIsArray) return _matchTag(find, tags, extra);

  for (let t of find) {
    const matched = _matchTag(t, tags, extra);
    if (matched === opAnd) continue; //AND: continue @ true, OR: continue @ false
    return !opAnd; //AND: any false => false, OR: any true => true
  }
  return opAnd;  //AND: all true => true, OR: all false => false
};



const defaults = {
  findArrayObjectbyAttr,
  saveBlobToFile,
  hashCode,
  parseUrlsToHtmlLinks,
  arabicToRoman,
  removeUnprintableChars,
  _matchTag,
  matchTagsOr,
  matchTagsAnd
};

export default defaults;
